module.exports = __webpack_public_path__ + "img/06.55a3a4d2.jpg";